import { render, staticRenderFns } from "./custom-function.vue?vue&type=template&id=2995bfb8&scoped=true"
import script from "./custom-function.vue?vue&type=script&lang=js"
export * from "./custom-function.vue?vue&type=script&lang=js"
import style0 from "./custom-function.vue?vue&type=style&index=0&id=2995bfb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995bfb8",
  null
  
)

export default component.exports